import { Badge } from "@/components/ui/badge"
import type { BookingSeasonSnapshot } from "@/app/appointments/booking-season/bookingSeasonApi"
import { bookingSeasonBannerText } from "../lib/bookingSeason"

/**
 * Whether the public can book right now, said once above the grid.
 *
 * The dotted slots say which times the public cannot book; this says whether they can book at all,
 * and — staff being the ones reading — why not when they cannot. Informational only: nothing on the
 * grid is held back by it.
 *
 * Draws nothing while the season is unknown, including when it could not be read. The calendar is
 * still the calendar without it, and a banner guessing "closed" would be the louder mistake.
 */
export function BookingSeasonBanner({ season }: { season: BookingSeasonSnapshot | undefined }) {
  const text = bookingSeasonBannerText(season)
  if (!season || !text) return null

  const open = season.status === "Open"

  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b bg-card px-5 py-1.5 text-xs text-muted-foreground"
    >
      <Badge
        variant={open ? "secondary" : "outline"}
        className="text-[0.65rem] font-semibold rounded"
      >
        {open ? "Open" : "Closed"}
      </Badge>
      <span className={open ? undefined : "text-foreground"}>{text}</span>
    </div>
  )
}
